import type { ComponentType } from 'react';

import { SentryConfigured } from 'app/packages/components/Sentry/SentryConfigured';

export const getAppWithSentryProfiler =
  (App: ComponentType<Record<string, never>>) => SentryConfigured.withProfiler(App);
